import ItemGroupEditor from "../components/ItemGroupEditor";

const ItemGroupEditPage = () => <ItemGroupEditor />;

export default ItemGroupEditPage;
